export default __webpack_public_path__ + "img/not-textbook-right-design.1693e64e.jpg";